<template>
  <div class="swiper-box">
    <div class="container">
      <div class="row">
        <headerTitle
          class="hidden-xs hidden-sm margintop"
          title="品牌企业"
          Entitle="Brand Enterprise"
          ranking="[排名不分先后]"
        />
        <div class="container customer-container visible-xs visible-sm">
          <p class="customer-title text-center">品牌企业</p>
          <p class="text-center">Brand Enterprise</p>
        </div>
        <swiper class="swiper hidden-xs" :options="swiperOption">
          <swiper-slide v-for="item in customerList" :key="item.id">
            <a v-if="item.web === ''" href="javascript:;"
              ><img class="logo-img" :src="item.logoImage" alt="品牌logo"
            /></a>
            <a v-else :href="item.web" target="_blank"
              ><img class="logo-img" :src="item.logoImage" alt="品牌logo"
            /></a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <swiper class="swiper visible-xs" :options="swiperOptions">
          <swiper-slide v-for="item in customerList" :key="item.id">
            <a v-if="item.web === ''" href="javascript:;"
              ><img class="logo-img" :src="item.logoImage" alt="品牌logo"
            /></a>
            <a v-else :href="item.web" target="_blank"
              ><img class="logo-img" :src="item.logoImage" alt="品牌logo"
            /></a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
          <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { brand } from "@/api/api";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import HeaderTitle from "@/components/HeaderTitle";
export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderTitle,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        slidesPerColumn: 4,
        spaceBetween: 10,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          // el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptions: {
        slidesPerView: 2,
        slidesPerColumn: 4,
        spaceBetween: 10,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          // el: ".swiper-pagination",
          clickable: true,
        },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      },
      customerList: [],
    };
  },
  created() {
    this.getBrand();
  },
  methods: {
    //获取品牌logo图标
    async getBrand() {
      const res = await brand();
      if (res.code === 200) {
        console.log("获取品牌logo图标", res);
        this.customerList = res.data;
      }
    },
  },
};
</script>

<style scoped lang="scss" >
.margintop {
  padding: 20px 0;
}
.swiper-box {
  // padding: 10px 10%;
  background: #efefef;
  /* 品牌企业LOGO展示 */
  .customer-container {
    padding: 50px 0;
    box-sizing: border-box;
    transition: all ease 0.6s;
    .customer-title {
      font-size: 30px;
      color: #0080c9;
    }
  }
  .swiper {
    width: 97%;
    height: 500px;
    margin-left: auto;
    margin-right: auto;
    .swiper-slide {
      border-radius: 5px;
      height: 100px;
      border: 1px solid #ccc;
      .logo-img {
        border-radius: 5px;
        width: 100%;
        height: 100%;
      }
    }
  }
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .swiper-box .customer-container {
     padding: 25px 0 15px 0;
  }
  .swiper-box .swiper{
    height: 458px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BrandLogo.vue